var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "u730q6elsa",
    width: "107.2%",
    height: "110.2%",
    x: "-3.1%",
    y: "-3.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.750533394 0 0 0 0 0.750533394 0 0 0 0 0.750533394 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q9c4rsowbc",
    width: "107.2%",
    height: "111.9%",
    x: "-3.1%",
    y: "-4.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.750533394 0 0 0 0 0.750533394 0 0 0 0 0.750533394 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "u8zzx31f8b",
    d: "M0 0H967V687H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xfmvhkx78d",
    d: "M0 0H968V588H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nwjfvhihse",
    cx: 32.607,
    cy: 32.607,
    r: 32.607
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M0 0H1440V1024H0z",
    transform: "translate(-531 -315)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531 -315) translate(337 257)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#u730q6elsa)",
    xlinkHref: "#u8zzx31f8b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#u8zzx31f8b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 56H493V687H0z",
    transform: "translate(-531 -315) translate(337 257)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeLinecap: "square",
    d: "M0 0.5L967 0.5",
    transform: "translate(-531 -315) translate(337 257) translate(0 103)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M0 0H1440V1024H0z",
    transform: "translate(-531 -315)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531 -315) translate(336 164)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#q9c4rsowbc)",
    xlinkHref: "#xfmvhkx78d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#xfmvhkx78d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H73V73H0z",
    transform: "translate(-531 -315) translate(336 164) translate(192 148)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531 -315) translate(336 164) translate(192 148) translate(3.893 3.893)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "nonzero",
    stroke: "#DFDFDF",
    xlinkHref: "#nwjfvhihse"
  })))), /*#__PURE__*/React.createElement("text", {
    fill: "#96A6BF",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 13,
    transform: "translate(-531 -315)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 552,
    y: 354
  }, "Icon"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty_icon.593bf02919474c1784a5269644deac11.svg";
export { ForwardRef as ReactComponent };